export function getImageSrc(imageName: string): string {
  // if (window.location.hostname === 'localhost') {
  //   return `/assets/${imageName}`;
  // }
  return `https://vstatic-prod.apigateway.co/partner-center-client/assets/${imageName}`;
}
